import { createSelector } from 'reselect';
import { routerSelectors } from '~/selectors';

export const selectJourneyState = (state) => state.journeyState;

export const selectSelectedFacets = createSelector(
  selectJourneyState,
  (journeyState) => journeyState.selectedFacets,
);

export const selectSearchQuery = createSelector(
  selectJourneyState,
  (journeyState) => journeyState.searchQuery,
);

export const selectPrevPathConfigs = createSelector(
  selectJourneyState,
  (journeyState) => journeyState.prevPathConfigs,
);

export const selectPathConfigForPage = createSelector(
  selectPrevPathConfigs,
  routerSelectors.selectLocation,
  (prevPathConfigs, { pathname }) => {
    const filteredPrevPathConfig = prevPathConfigs.filter((e) => e.path === pathname);
    return filteredPrevPathConfig.length > 0 ? filteredPrevPathConfig[0] : {};
  },
);

export const selectAnalytics = createSelector(
  selectJourneyState,
  (journeyState) => journeyState.analytics,
);

export const selectProgressBarItemConfigs = createSelector(
  selectJourneyState,
  (journeyState) => journeyState.progressBarItemConfigs,
);

export const journeyStateSelectors = {
  selectJourneyState,
  selectSearchQuery,
  selectSelectedFacets,
  selectPathConfigForPage,
  selectAnalytics,
  selectProgressBarItemConfigs,
};
